import {TreeMapModel} from '@xh/hoist/cmp/treemap';
import {HoistModel, LoadSpec, managed, XH} from '@xh/hoist/core';
import {Store} from '@xh/hoist/data';
import {Timer} from '@xh/hoist/utils/async';
import {fmtPercent} from '@xh/hoist/format';
import {SectorExposure} from '../../../../data/DataTypes';
import {moneyFormatter} from '../../../../cmp/Formaters';
import {getDefaultOptions} from '../../../../../core/ServiceUtils';

export class SectorMapWidgetModel extends HoistModel {
    @managed treeMapModel: TreeMapModel;
    @managed store: Store;
    @managed private timer = Timer.create({interval: 5000, runFn: () => this.loadAsync({isRefresh: true})});

    override onLinked() {
        super.onLinked();

        this.store = new Store({
            idSpec: 'sector',
            fields: [
                {name: 'sector', type: 'string', displayName: 'Sector'},
                {name: 'marketValue', type: 'number', displayName: 'Market Value'},
                {name: 'dailyChangePct', type: 'number', displayName: 'Daily Change %'}
            ]
        });

        this.treeMapModel = new TreeMapModel({
            store: this.store,
            colorMode: 'linear',
            labelField: 'sector',
            valueField: 'marketValue',
            heatField: 'dailyChangePct',
            // Colors scale to a fixed 2% move rather than to the day's biggest mover, which left every other sector
            // near the faint end. Hoist maps a fall to 0-0.4 and a rise to 0.6-1, so a 1% move lands on the middle
            // stop of its side, and a move past 2% keeps the end color.
            maxHeat: 0.02,
            // Saturated palette in both themes, so even a small move reads clearly red or green. Labels stay white over every stop.
            highchartsConfig: {
                colorAxis: {
                    stops: [
                        [0, '#ff3b4a'],
                        [0.2, '#d6303f'],
                        [0.4, '#9e2f3a'],
                        [0.5, '#4a4f5c'],
                        [0.6, '#257a45'],
                        [0.8, '#22a456'],
                        [1, '#2ecc66']
                    ]
                },
                plotOptions: {
                    treemap: {
                        borderColor: 'rgba(0, 0, 0, 0.35)',
                        dataLabels: {style: {color: '#ffffff', textOutline: '1px rgba(0, 0, 0, 0.4)'}}
                    }
                }
            },
            valueRenderer: v => moneyFormatter(v),
            heatRenderer: v =>
                fmtPercent(v, {
                    precision: 2,
                    colorSpec: true,
                    asHtml: true
                }) as any
        });
    }

    override async doLoadAsync(_loadSpec: LoadSpec): Promise<void> {
        const data: SectorExposure[] = await XH.fetchService.fetchJson({
            url: `${XH.getConf('svcApiUrl')}/SectorExposure/TotalByUser`,
            method: 'GET',
            ...getDefaultOptions()
        });
        this.store.loadData(data);
    }
}
